import ApiClient from 'api-client/ApiClient'
import ActionsSet from 'core/actions/ActionsSet'
import CreateAction from 'core/actions/CreateAction'
import ListAction from 'core/actions/ListAction'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import Bugsnag from 'utils/bugsnag'
import { pathStr } from 'utils/fp'
import { trackEvent } from 'utils/tracking'

const { kubernetes } = ApiClient.getInstance()

export const kaapiBYOMachineTemplateActions = ActionsSet.make<DataKeys.KaapiBYOMachineTemplates>({
  uniqueIdentifier: 'metadata.uid',
  entityName: entityNamesByKey[DataKeys.KaapiBYOMachineTemplates],
  cacheKey: DataKeys.KaapiBYOMachineTemplates,
})

export const listKaapiBYOMachineTemplates = kaapiBYOMachineTemplateActions.add(
  new ListAction<DataKeys.KaapiBYOMachineTemplates, { namespace: string }>(
    async ({ namespace }) => {
      Bugsnag.leaveBreadcrumb('Attempting to list Kaapi BYOMachineTemplates', { namespace })
      return kubernetes.getAllCustomResources(DataKeys.KaapiBYOMachineTemplates)
    },
  ),
)

export const createKaapiBYOMachineTemplate = kaapiBYOMachineTemplateActions.add(
  new CreateAction<DataKeys.KaapiBYOMachineTemplates, { namespace: string; body: any }>(
    async ({ namespace, body }) => {
      Bugsnag.leaveBreadcrumb('Attempting to create Kaapi ByoMachineTemplate', { namespace, body })
      const created = await kubernetes.createCustomResource({
        type: DataKeys.KaapiBYOMachineTemplates,
        body,
      })
      trackEvent('Create New Kaapi ByoMachineTemplateAction', {
        namespace,
        name: pathStr('metadata.name', created),
      })
      return created
    },
  ),
)
